import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { TipologiaCostruttiva } from 'src/app/models/tipologia-costruttiva';
import { TipologiaCostruttivaService } from 'src/app/services/tipologia-costruttiva.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { TipologieCostruttiveFormComponent } from './dialogs/form/form.component';

@Component({
  selector: 'tipologie-costruttive',
  templateUrl: './tipologie-costruttive.component.html',
  styleUrls: ['./tipologie-costruttive.component.scss']
})
export class TipologieCostruttiveComponent implements OnInit {

  headingText: string = 'Tipi di danno';


  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),

  ];
  constructor(public tipologiaCostruttivaService: TipologiaCostruttivaService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<TipologieCostruttiveComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un tipo di danno';
    }
  }

  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => this.search = newValues);

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (tipologiaCostruttiva: TipologiaCostruttiva) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare il tipo di danno ${tipologiaCostruttiva.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.tipologiaCostruttivaService.delete(tipologiaCostruttiva);
          this.toast.success('Tipo di danno eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione tipo di danno fallita.", "Errore!");
    }
  }



  editFunction = async (tipologiaCostruttiva: TipologiaCostruttiva) => {
    try {
      let dialogRef = this.dialog.open(TipologieCostruttiveFormComponent, { data: tipologiaCostruttiva });
      dialogRef.afterClosed().subscribe(async (data: TipologiaCostruttiva) => {
        if (data) {

          Object.assign(tipologiaCostruttiva, data);

          await this.tipologiaCostruttivaService.edit(tipologiaCostruttiva);

          this.toast.success('Tipo di danno modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica tipo di danno fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(TipologieCostruttiveFormComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(tipologiaCostruttiva?: TipologiaCostruttiva) {
    if (tipologiaCostruttiva) {
      try {
        await this.tipologiaCostruttivaService.create(tipologiaCostruttiva)
        this.toast.success('Tipo di danno creato!')
      }
      catch (e) {
        this.toast.error('Creazione tipo di danno fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
